import "./SpecialistAccessScaffolding.module.css";
import Header from "@/reusable_sections/Header";
import SpecialistAccess from "./sections/SpecialistAccess";
import RelatedServices from "./sections/RelatedServices";
import Footer from "@/reusable_sections/Footer";
export default function SpecialistAccessScaffoldingPage() {
  return <div>
      <Header />
      <SpecialistAccess />
      <RelatedServices />
      <Footer />
    </div>;
}